import { treeFilter } from "@homebound/beam";
import { useMemo } from "react";
import { useProjectCommunityFilterMetadataQuery } from "src/hooks/filters/projectCommunity/useProjectCommunityFilter.generated";
import { groupBy } from "src/utils";

type UseProjectCommunityFilterProps = { skip?: boolean };

export function useProjectCommunityFilter(props: UseProjectCommunityFilterProps = {}) {
  const { skip } = props;
  const { data } = useProjectCommunityFilterMetadataQuery({ fetchPolicy: "cache-first", skip });
  const projectCommunityFilter = useMemo(
    () =>
      treeFilter({
        defaultCollapsed: true,
        label: "Community",
        filterBy: "leaf",
        getOptionLabel: (o) => o.name,
        getOptionValue: (o) => o.id,
        options: Object.values(
          groupBy(
            (data?.projects ?? []).filter((p) => p.market),
            (p) => p.market!.id,
          ),
        ).map((communities) => ({
          id: communities[0].market!.id,
          name: communities[0].market!.name,
          children: communities.map((c) => ({ id: c.id, name: c.name })),
        })),
      }),
    [data],
  );

  return { projectCommunityFilter, options: data?.projects ?? [] };
}
